import Flex from "components/grid/Flex";
import { useTranslation } from "react-i18next";
import HistoryContainerAndTitle from "./HistoryContainerAndTitle";
import { isAnyPresent, makeHistory } from "../../HistoryUtils";
import ConditionalLabelAndValue from "./ConditionalLabelAndValue";
import Date from "./Date";
import { Typography } from "@material-ui/core";

const HivHistory = ({ anamnesisHistory }) => {
    const { t } = useTranslation();
    const history = makeHistory(anamnesisHistory);
    const isVisible = isAnyPresent(anamnesisHistory, [
        "hasHivDiagnosis",
        "hivDiagnosisDate",
        "hivTherapyType",
        "hivTherapyMedication",
    ]);
    return (
        <HistoryContainerAndTitle title={t(`anamnesis.hiv.title`)} isVisible={isVisible}>
            <Flex item grow={0} container column style={{ margin: "5px 0px" }}>
                <ConditionalLabelAndValue
                    {...{
                        switchValue: history.getLatestValueOf("hasHivDiagnosis"),
                        label: t("anamnesis.hiv.hivPositive"),
                        valueComponent: (
                            <>
                                <Date
                                    date={history.getLatestValueOf("hivDiagnosisDate") || ""}
                                    style={{ alignItems: "none", marginRight: "10px", minWidth: 150 }}
                                />
                                <Typography>
                                    {`${history.getLatestValueOf("hivTherapyType") ? "therapy: " + history.getLatestValueOf("hivTherapyType") : ""}` +
                                        `${history.getLatestValueOf("hivTherapyMedication") ? ", medication: " + history.getLatestValueOf("hivTherapyMedication") : ""}`}
                                </Typography>
                            </>
                        ),
                    }}
                />
            </Flex>
        </HistoryContainerAndTitle>
    );
};

export default HivHistory;
